/**
 * Payment trust strip — PayFast + the payment methods it processes for us.
 * Rendered on every payment-connected portal surface (public pay page,
 * checkout steps, invoice detail, auto-pay setup) so customers understand
 * payments are secure. Mirrors marketing's PaymentMethodsStrip and the
 * EmailPaymentTrustStrip primitive in the email templates.
 *
 * Assets: /payment-logos/*.png (portal/public — sourced from the PayFast
 * merchant "Payment Methods Logo Pack"). Logos keep their brand colours on
 * white chips — recognition is the trust signal.
 */

const METHODS = [
  { name: 'PayFast', file: 'payfast.png' },
  { name: 'Visa', file: 'visa.png' },
  { name: 'Mastercard', file: 'mastercard.png' },
  { name: 'Instant EFT', file: 'instant-eft.png' },
  { name: 'Capitec Pay', file: 'capitec-pay.png' },
  { name: 'SnapScan', file: 'snapscan.png' },
  { name: 'Zapper', file: 'zapper.png' },
  { name: 'Mobicred', file: 'mobicred.png' },
];

interface PaymentTrustStripProps {
  className?: string;
  /** Compact renders smaller chips without the security caption — for tight
   *  card layouts like the public pay page. */
  compact?: boolean;
}

export function PaymentTrustStrip({ className, compact = false }: PaymentTrustStripProps) {
  return (
    <div className={className}>
      <div className="flex flex-wrap justify-center items-center gap-2">
        {METHODS.map((m) => (
          <div
            key={m.name}
            className="flex items-center justify-center rounded border border-border bg-card px-2.5 py-1.5 shadow-sm"
            title={m.name}
          >
            <img
              src={`/payment-logos/${m.file}`}
              alt={m.name}
              className={compact ? 'h-4 w-auto object-contain' : 'h-5 w-auto object-contain'}
              loading="lazy"
              decoding="async"
            />
          </div>
        ))}
      </div>
      {!compact && (
        <p className="mt-2 text-center text-xs text-muted-foreground">
          Payments are processed securely by PayFast (PCI DSS Level 1) with 3-D
          Secure. We never see or store your card details.
        </p>
      )}
    </div>
  );
}

export default PaymentTrustStrip;
